
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE, SeCoreModule } from '../core/core.module'
import { SE_SPINNER_MODULE_BUNDLE, SeSpinnerModule } from '../spinner/spinner.module'
import { SE_OVERLAY_MODULE_BUNDLE, SeOverlayModule } from '../overlay/overlay.module'

import { SeDialogComponent } from './dialog.component'
import { SeDialogFooterComponent } from './dialog-footer.component'
import { SeDialogHelper } from './dialog-helper'

@NgModule({
  declarations: [
    SeDialogComponent,
    SeDialogFooterComponent,
  ],
  exports: [
    SeDialogComponent,
    SeDialogFooterComponent,
  ],
  providers: [
    SeDialogHelper,
  ],
  imports: [
	CommonModule, 
    SeCoreModule,
    SeSpinnerModule,
    SeOverlayModule
  ]
})
export class SeDialogModule {}

const dependencies = [
  SE_CORE_MODULE_BUNDLE,
  SE_SPINNER_MODULE_BUNDLE,
  SE_OVERLAY_MODULE_BUNDLE
]

export const SE_DIALOG_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.dialog`
export { SeDialogComponent, SeDialogOptions, SeDialogSize, SeDialogAction } from './index'

